
<div class="header-toolbar">
  <h1 *ngIf="mode === 'edit' || mode === 'new'">{{ title }}</h1>
  <h1 *ngIf="mode === 'view'">
    {{ user?.username }}
    <span *ngIf="user?.deleted">Supprimé</span>
  </h1>
</div>


<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="user">

  <!-- Toolbar -->
  <div *ngIf="mode === 'edit' || mode === 'new'" class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!user.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  
  <div *ngIf="mode === 'view' && !user.deleted" class="main btn-toolbar">
    
    <div class="btn-group" *ngIf="!user.emailVerified">
      <div class="content">
        
        <button class="btn" (click)="resendEmailVerification()">
          <t-icon name="arrow_forward"></t-icon>
          <span class="text">Renvoyer l'invitation</span>
        </button>

      </div>
    </div>
    
    <div class="btn-group">
      <div class="content">
        
        <a class="btn" [routerLink]="['edit']">
          <t-icon name="mode_edit"></t-icon>
          <span class="text">Modifier</span>
        </a>
        <button class="btn" (click)="delete()">
          <t-icon name="delete"></t-icon>
          <span class="text">Supprimer</span>
        </button>

      </div>
    </div>

  </div>

  <div *ngIf="mode === 'view' && user.deleted" class="main btn-toolbar">
        
    <button class="btn" (click)="restore()">
      <t-icon name="settings_backup_restore"></t-icon>
      <span class="text">Restaurer</span>
    </button>
    
    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="user">

    <div class="column">

      <ng-container *ngIf="mode === 'edit' || mode === 'new'">

        <t-user-auth [user]="user"></t-user-auth>

        <t-user-details [user]="user"></t-user-details>

      </ng-container>

      <div *ngIf="mode === 'view'" class="panel">
        <h2>Utilisateur client</h2>
      
        <div class="form-group">
          <label>Nom d'utilisateur</label>
          <span class="value">{{ user.username }}</span>
        </div>

        <div class="form-group">
          <label>Adresse email</label>
          <span class="value" *ngIf="user.emailVerified">Vérifiée</span>
          <span class="value" *ngIf="!user.emailVerified">Non vérifiée</span>
          <span class="value" *ngIf="user.latestEmailVerification"><br/>
            En attente de la vérification de l'adresse {{ user.latestEmailVerification.email }}
          </span>
        </div>

        <div class="form-group">
          <label>Prènom</label>
          <span class="value">{{ user.firstname || '-' }}</span>
        </div>

        <div class="form-group">
          <label>Nom</label>
          <span class="value">{{ user.lastname || '-' }}</span>
        </div>

        <div class="form-group">
          <label>Fuseau horaire</label>
          <span class="value">{{ user.timezone }}</span>
        </div>
      </div>
      
    </div>
    
    <div class="column">

      <div class="panel">
        <h2>Compte/Role</h2>

        <div *ngIf="mode === 'view' || mode === 'edit'" class="form-group clickable" (click)="showCLAccount()">
          <label>Compte client</label>
          <span class="value">{{ user.account.name }}</span>
        </div>

        <div class="form-group" *ngIf="mode === 'new'">
          <label>Compte client</label>

          <span id="type" class="value">{{ user.account?.name || '-' }}</span>
          <span class="info info-error" [hidden]="user.account">Veuillez sélectionner un compte client</span>

          <div class="text-right">
            <a class="btn btn-small btn-gray" title="Sélectionner un compte client" (click)="lookupAccount($event)">
              <t-icon name="search"></t-icon>
              <span class="text">Recherche</span>
            </a>
          </div>

        </div>

        <div *ngIf="mode === 'view' || mode === 'edit'" class="form-group">
          <label>Role</label>
          <span class="value">{{ user.role | cluserrole }}</span>
        </div>

        <div *ngIf="mode === 'new'" class="form-group">
          <label>Role</label>
          <t-option [options]="userRoleOptions" [(value)]="user.role"></t-option>
        </div>
      </div>

      <div *ngIf="mode === 'view' || mode === 'edit'" class="panel">
        <h2>Autres</h2>
      
        <div class="form-group">
          <label for="id">Identifiant</label>
          <span id="id" class="value">{{ user.id }}</span>
        </div>
      
        <div class="form-group">
          <label for="createdAt">Date d'ajout</label>
          <span id="createdAt" class="value">{{ user.createdAt | tzdate }}</span>
        </div>
      
        <div class="form-group">
          <label for="updatedAt">Date de modification</label>
          <span id="updatedAt" class="value">{{ user.updatedAt | tzdate }}</span>
        </div>
      </div>

    </div>

  </div>
</form>